import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorWindowComponent } from './shared/components/error-window/error-window.component';
import { RoleGuard } from './shared/services/access-roles/role-guard.service';
import { AccessRoles } from './shared/entity/constants';

export function isInIframe() {
  return window !== window.parent && !window.opener;
}

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: 'error',
        component: ErrorWindowComponent,  canActivate: [MsalGuard],
      },
      {
        path: '',
        loadChildren: () => import('./modules/layout/layout.module').then(m => m.LayoutModule),
        data: {
          roles:
            [
              AccessRoles.GLOBALADMINISTRATOR,
              AccessRoles.ADMINISTRATOR,
              AccessRoles.MANAGER,
              AccessRoles.INTELLIGENCE,
              AccessRoles.GLOBALINTELLIGENCE,
              AccessRoles.SUPERUSER
            ]
        },
        canActivate:[MsalGuard, RoleGuard]
      },
      {
        path: 'error',
        component: ErrorWindowComponent,  canActivate: [MsalGuard],
      },
      {
        path:'**',
        redirectTo:'/auth',
        pathMatch:'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { useHash: true, onSameUrlNavigation: 'reload', initialNavigation: isInIframe() ? 'disabled' : undefined, enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
